import React, { useState } from "react";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import "./Weather.css";


export default function Weather(props){

  const [weatherData, setWeatherData] = useState({ready: false});
  const [city, setCity] = useState(props.defaultCity);  

function handleResponse(response){
  
  setWeatherData({
    ready: true,
    coordinates: response.data.coord,
    city: response.data.name,
    temperature: response.data.main.temp,
    description: response.data.weather[0].description,
    date: new Date(response.data.dt * 1000),
    wind: response.data.wind.speed,
    humidity: response.data.main.humidity,
    icon: response.data.weather[0].icon,
  });  
}
function handleSubmit(event){
  event.preventDefault();
  search();
}

function handleCityChange(event){
  setCity(event.target.value);
}
function search(){
const apiKey = "5f472b7acba333cd8a035ea85a0d4d4c";
let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=imperial`;
axios.get(apiUrl).then(handleResponse);
}



if(weatherData.ready){
return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="search"
                placeholder="enter desired city..."
                className="form-control"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>
            <div className="col-3">
              <input type="submit" value="Search" className="btn btn-primary w-100" />
            </div>
          </div>
        </form>
<WeatherInfo data={weatherData}/>
<WeatherForecast coordinates={weatherData.coordinates}/>
      </div>
    );
} else {
  search();
  return "Loading...";
}
}




     

